<template lang="pug">
    v-container
        div.footer 
            AppMembers
            div.menuCopy
                div.footMenuWrap 
                    AppFooterMenu.right
                div.copy Министерство национальной политики УР © 2020г.
        
</template>

<script>
    import AppMembers from '@/components/AppMembers.vue'
    import AppFooterMenu from '@/components/AppFooterMenu.vue'
    export default {
        components: {
            AppMembers,
            AppFooterMenu
        }
    }
</script>

<style lang="scss" scoped>
    .footer {
        font-family: Segoe UI;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 32px;
        color: #757575;
    }
    .menuCopy {
        background: url(/images/footer-bg.png) no-repeat;
        background-size: cover;
        padding: 10px;
        font-size: 16px;
    }
    .footMenuWrap {
        overflow: hidden;
        display:none;
    }
    .footMenuWrap .right {float:right;}

    @media (min-width:600px) {
        
    }
    @media (min-width:960px) {
        
    }
    @media (min-width:1264px) {
        
    }
    @media (min-width:1904px) {
        .menuCopy {
            margin-top: 50px;
            padding: 32px 238px 16px 104px;
        }
        .footMenuWrap {
            display:block;
        }
    }
</style>